import { render, staticRenderFns } from "./Food.vue?vue&type=template&id=df47bc5c&scoped=true&"
import script from "./Food.vue?vue&type=script&lang=js&"
export * from "./Food.vue?vue&type=script&lang=js&"
import style0 from "./Food.vue?vue&type=style&index=0&id=df47bc5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df47bc5c",
  null
  
)

export default component.exports